// extracted by mini-css-extract-plugin
export default {"root":"UnorderedList-root-9cd615289246a7ecbea657c99f833472"};